/**
 * @import { CruiseSearchResult } from '@/features/world-map/types/cruise-search-result'
 * @import { Filters } from '@/features/world-map/types/filters'
 */

import { config } from '@/config/config';
import { api } from '@/lib/api-client';
import { checkErrorCode } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';

/**
 * @typedef {object} SearchResponse
 * @property {number} [errorCode]
 * @property {CruiseSearchResult[]} data
 */

const path = `cruises/search/${config.office}/${config.currencyCode}`;

/**
 * @param {Filters} filters
 */
export function useCruiseSearch(filters) {
  return useQuery({
    queryKey: [path, filters],
    queryFn: async ({ signal }) => {
      const response = await api.post(path, filters, { signal });
      const content = /** @type {SearchResponse} */ (await response.json());
      checkErrorCode(content);
      return content.data;
    },
    placeholderData: (prev) => prev,
    staleTime: Infinity,
  });
}
